import { useMutation, useQueryClient } from "@tanstack/react-query";
import { consumedBudgetKeyMaker } from "../../Rebalance/hooks/useGetConsumedBudget";
import postTaxBudget from "../request/postTaxBudget";
import { taxBudgetsKeyMaker } from "./useGetTaxBudgets";
export default function useCreateTaxBudget(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (request) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postTaxBudget(request, config);
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: taxBudgetsKeyMaker(null),
            });
            const clientIds = data?.data.clientIds ?? [];
            if (clientIds[0]) {
                queryClient.invalidateQueries({
                    queryKey: taxBudgetsKeyMaker({
                        clientId: [clientIds[0]],
                    }),
                });
                queryClient.invalidateQueries({
                    queryKey: consumedBudgetKeyMaker({
                        clientId: clientIds[0],
                    }),
                });
            }
            if (clientIds[1]) {
                queryClient.invalidateQueries({
                    queryKey: taxBudgetsKeyMaker({
                        clientId: [clientIds[1]],
                    }),
                });
                queryClient.invalidateQueries({
                    queryKey: consumedBudgetKeyMaker({
                        clientId: clientIds[1],
                    }),
                });
            }
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePostTaxBudget.js.map